module.exports = __webpack_public_path__ + "img/product-details-6.33f915a1.svg";